'use client';
import { Authenticator } from '@aws-amplify/ui-react';
import { PropsWithChildren } from 'react';

export function AmplifyAuthProvider({ children }: PropsWithChildren) {
  return <Authenticator.Provider>{children}</Authenticator.Provider>;
}
